export const UI_MESSAGES = {
  common: {
    unexpectedError: 'Ocurrió un error inesperado.',
    networkError: 'No hay conexión con el servidor. Verificá tu red e intentá nuevamente.',
    statusError: (actionLabel, status) => `Error al ${actionLabel}. Estado: ${status}`,
    invalidImageType: 'Solo se permiten archivos JPEG, JPG y PNG',
    invalidImageSize: 'El archivo no debe superar los 3 MB'
  },
  auth: {
    sessionExpired: 'Tu sesión expiró. Redirigiendo al login...'
  },
  permissions: {
    forbiddenGeneric: 'No tenés permisos para acceder a este recurso.',
    forbiddenFileReport: 'No tenés permisos para ver o eliminar este reporte.',
    forbiddenMonitor: 'No tenés acceso a la entidad o datapoint solicitado.',
    forbiddenReporting: 'No tenés permisos para consultar estos datos de consumo.',
    forbiddenDevice: 'No tenés permisos para operar sobre este datapoint.',
    forbiddenEntity: 'No tenés permisos para operar sobre esta entidad.',
    forbiddenLocality: 'No tenés permisos para operar sobre esta localidad.'
  },
  server: {
    generic: 'Ocurrió un error del servidor. Intentá nuevamente.',
    fileReport: 'No se pudo completar la operación de reportes. Intentá nuevamente.',
    reporting: 'No se pudieron obtener los datos de consumo. Intentá nuevamente.',
    monitor: 'No se pudieron cargar los indicadores del monitor. Intentá nuevamente.',
    realTime: 'No se pudieron obtener los datos en tiempo real. Intentá nuevamente.'
  },
  reports: {
    reportIdRequired: 'El ID del reporte es obligatorio.',
    loadError: 'Error al cargar el reporte.',
    listLoadErrorPrefix: 'Error al cargar reportes: ',
    downloadContentError: (status) => `Error al descargar el contenido del reporte. Estado: ${status}`,
    dateRangeInvalid: 'La fecha de fin debe ser mayor o igual a la fecha de inicio',
    createError: 'Error al generar el reporte',
    deleteInvalidFileId: 'ID de archivo no válido',
    deleteError: 'Error al eliminar el reporte'
  },
  chart: {
    loadError: 'Error al obtener los datos del gráfico',
    noDataAvailable: 'Sin datos disponibles para este parámetro',
    invalidApiData: 'La respuesta de la API no contiene datos válidos',
    invalidProcessData: 'Datos inválidos en el procesamiento del gráfico'
  },
  realTime: {
    consolidatedLoadError: 'Error al obtener datos en tiempo real consolidados'
  },
  entity: {
    invalidEmail: 'Por favor ingrese un correo electrónico válido.',
    duplicatedEmail: 'Este correo ya existe en la lista.',
    invalidEmailHelper: 'Correo no válido',
    formFixErrors: 'Por favor, corrija los errores en el formulario.',
    duplicatedName: 'El nombre de la entidad ya existe. Por favor, elija otro nombre.',
    createdSuccess: (entityName) => `La entidad ${entityName} fue creada correctamente.`,
    createError: 'Error al crear la entidad. Intente nuevamente.',
    fetchError: 'Error al obtener entidades existentes',
    updatedSuccess: (entityName) => `La entidad ${entityName} fue modificada correctamente.`,
    updateError: 'Error al modificar la entidad. Intente nuevamente.',
    deleteSuccess: 'La entidad fue eliminada correctamente.',
    deleteError: 'Error al eliminar la entidad. Intente nuevamente.'
  },
  locality: {
    invalidEmailHelper: 'Email inválido',
    formFixErrors: 'Por favor, corrija los errores en el formulario.',
    duplicatedName: 'El nombre de la locación ya existe. Por favor, elija otro nombre.',
    createdSuccess: (localityName) => `La locación ${localityName} fue creada correctamente.`,
    createError: 'Error al crear la locación. Intente nuevamente.',
    updatedSuccess: (localityName) => `La locación ${localityName} fue modificada correctamente.`,
    updateError: 'Error al actualizar la locación. Intente nuevamente.',
    deleteSuccess: 'La locación fue eliminada correctamente.',
    deleteError: 'Error al eliminar la locación. Intente nuevamente.'
  },
  device: {
    invalidGuid: 'Datapoint ID no válido',
    notFoundError: 'Datapoint no encontrado.',
    unavailableError: 'El datapoint no está disponible.',
    notExistsSnackbar: 'No existe el datapoint.',
    alreadyAssignedOtherUser: 'El datapoint ya se encuentra asignado a otro usuario.',
    alreadyAssigned: 'El datapoint ya fue asignado.',
    assignedSuccess: 'El datapoint se asignó correctamente.',
    verifyError: 'Error al verificar el datapoint.',
    formFixErrors: 'Por favor, complete los campos obligatorios del datapoint.',
    updatedSuccess: 'El datapoint se actualizó correctamente. Los cambios realizados pueden tomar hasta 15 minutos en impactarse.',
    updateError: 'Error al actualizar el datapoint.',
    deleteSuccess: 'El datapoint fue eliminado y quedó desvinculado correctamente.',
    deleteError: 'Error al eliminar el datapoint. Intente nuevamente.'
  },
  customEvent: {
    saveSuccess: 'La configuración se guardó correctamente. Puede tomar hasta 15 minutos en tomar efecto.',
    saveError: 'Error al guardar la configuración',
    rangeValidationError: (cardTitle) => `El valor "Menor a" debe ser menor que "Mayor a" en la tarjeta "${cardTitle}".`
  },
  dashboard: {
    entityNotFound: 'Entidad no encontrada o compartida.',
    createHere: 'Crear aquí',
    noEntityData: 'No hay datos para la entidad.',
    comparedConsumptionTitle: 'Consumo Comparado',
    noEvents: 'Sin eventos'
  },
  entityRoles: {
    editDeniedTitle: 'Acceso restringido',
    editDeniedDescription: 'No tenés permisos para modificar esto. Solo los roles Owner o Admin de la entidad pueden editarlo.',
    noManageableEntities: 'No tenés entidades donde seas Owner o Admin, por lo que no podés crear nuevos elementos. Pedile a un Owner que te asigne el rol Admin.',
    title: '¿Qué puede hacer cada rol?',
    ownerLabel: 'Owner',
    ownerDescription:
      'Propietario de la entidad. Puede hacer todo lo que hace un Admin y además asignar el rol Owner a otros usuarios y eliminar la entidad. Un Owner no puede ser eliminado ni cambiado de rol.',
    adminLabel: 'Admin',
    adminDescription:
      'Gestiona la entidad: edita entidad, locaciones y datapoints, configura eventos personalizados y gráficos guardados, genera y elimina reportes y administra los accesos (agregar o quitar Admin y Viewer). No puede asignar el rol Owner ni eliminar la entidad.',
    viewerLabel: 'Viewer',
    viewerDescription:
      'Solo lectura: ve dashboard, tiempo real, históricos, eventos, consumo y descarga reportes. No puede modificar nada.'
  },
  onboarding: {
    guideTitle: '¡Bienvenido a DIIOT!',
    guideSubtitle: 'Todavía no tenés datapoints. Seguí estos pasos para configurar tu cuenta por primera vez.',
    steps: [
      {
        label: 'Creá tu Entidad',
        description: 'La entidad agrupa tus locaciones y datapoints (por ejemplo, tu empresa u organización).',
        action: 'Crear entidad',
        url: '/entidad/nuevaEntidad'
      },
      {
        label: 'Creá una Locación',
        description: 'La locación es el lugar físico donde están instalados tus medidores (sucursal, planta, edificio).',
        action: 'Crear locación',
        url: '/locacion/nuevaLocacion'
      },
      {
        label: 'Asigná tu primer Datapoint',
        description: 'Registrá tu medidor en la locación para empezar a ver sus mediciones.',
        action: 'Crear datapoint',
        url: '/datapoint/nuevoDatapoint'
      }
    ],
    tourTitle: 'Un recorrido rápido por el menú',
    tourIntro: 'Ya tenés tu primer datapoint. Esto es lo que vas a encontrar en el menú lateral izquierdo:',
    tourItems: [
      { title: 'Dashboard', description: 'Resumen de consumo, consumo estimado, emisiones y eventos de tu entidad.' },
      {
        title: 'Datapoints',
        description:
          'La lista de tus medidores. Hacé clic en uno para desplegar sus secciones. El punto de color indica si está online, offline o nunca se conectó.'
      },
      { title: 'Parámetros Eléctricos', description: 'Gráficos de tensión, corriente, potencia y otros parámetros en el rango de fechas que elijas.' },
      { title: 'Tiempo Real', description: 'Mediciones del datapoint actualizándose en vivo.' },
      { title: 'Análisis Histórico', description: 'Consumo a lo largo del tiempo, agrupado por períodos y comparado.' },
      { title: 'Eventos', description: 'Eventos registrados por el datapoint.' },
      { title: 'Configuración de eventos', description: 'Personalizá qué eventos querés que registre el datapoint.' },
      { title: 'Reportes', description: 'Reportes de calidad eléctrica para consultar y descargar.' },
      { title: 'Configurar Datapoint', description: 'Nombre y parámetros de configuración del datapoint.' }
    ],
    tourClose: 'Entendido'
  },
  loading: {
    generic: 'Cargando información...',
    mainDashboard: 'Cargando panel principal...',
    realTime: 'Cargando datos en tiempo real...',
    customEventConfig: 'Cargando configuración de eventos...',
    events: 'Cargando eventos...',
    datapoints: 'Cargando datapoints...',
    locations: 'Cargando locaciones...',
    datapointInfo: 'Cargando información del datapoint...',
    reports: 'Cargando reportes...'
  },
  logs: {
    fetchMonitorDataError: 'Error al obtener datos de monitor',
    fetchEntityLogoError: 'Error al obtener logo de entidad',
    fetchChartDataError: 'Error al obtener datos del gráfico',
    fetchConsolidatedChartDataError: 'Error al obtener datos consolidados del gráfico',
    invalidConsolidatedData: 'Datos consolidados inválidos o estructura incorrecta',
    missingChartConfig: (chartType) => `Configuración no encontrada para el tipo de gráfico: ${chartType}`,
    invalidDateRangeFormat: 'Error al formatear rango de fechas',
    invalidDateFormat: 'Error al formatear fecha',
    assignDefaultEntityError: 'Error al asignar entidad por defecto',
    fetchEntityDataError: 'Error al obtener datos de entidad',
    fetchEntitiesError: 'Error al obtener entidades',
    fetchLocalitiesError: 'Error al obtener locaciones',
    fetchDeviceDataError: 'Error al obtener datos de datapoint',
    fetchTimeZonesError: 'Error al obtener zonas horarias',
    fetchCountriesError: 'Error al obtener países',
    fetchProvincesError: 'Error al obtener provincias',
    fetchCustomEventDataError: 'Error al obtener datos de eventos personalizados',
    fetchCreatorInfoError: 'Error al obtener información de creador',
    missingComparedConsumptionData: 'Los datos de consumo comparado no son válidos',
    authLoginNotImplemented: 'Login social aún no implementado',
    authRegisterNotImplemented: 'Registro social aún no implementado',
    apiResponseError: 'Error de respuesta',
    apiNetworkError: 'Error de red',
    apiGenericError: 'Error',
    apiConsolidatedResponseError: 'Error de respuesta consolidada',
    apiConsolidatedNetworkError: 'Error de red consolidada',
    apiConsolidatedGenericError: 'Error consolidado',
    tokenAccessError: 'Error al obtener token de acceso',
    loginRedirect401Error: 'Error al redirigir al login después de 401',
    serviceWorkerRegistrationError: 'Error durante el registro del service worker',
    unexpectedNetworkError: 'Error inesperado de red'
  }
};

export default UI_MESSAGES;
